/* PR 56 review (22-Oct) · R56-3 — the assertion headers of the vouching sheet in the screen's language. The assertion names
   ("Occurrence", "Completeness (Tx)" …) are also the KEYS stored on each row (``assertions``) — only the DISPLAY is
   translated here; the arrays and the stored keys never change. */
export const ASSERTION_SLUG = {
  "Occurrence": "occurrence", "Completeness (Tx)": "completenessTx", "Accuracy": "accuracy", "Cut-off": "cutOff",
  "Classification (Tx)": "classificationTx", "Presentation (Tx)": "presentationTx", "Existence": "existence",
  "Rights and Obligations": "rights", "Completeness (Bal)": "completenessBal", "Accuracy, Valuation and Allocation": "avva",
  "Classification (Bal)": "classificationBal", "Presentation (Bal)": "presentationBal",
};

const shortHead = (a) => String(a || "").replace(" (Tx)", "").replace(" (Bal)", "");

/** The header label of an assertion key. ``labels`` = the ``r56.assertions`` dictionary, or a ``t`` function. */
export function assertionLabel(key, labels) {
  const slug = ASSERTION_SLUG[key];
  if (!slug || !labels) return shortHead(key);
  const v = typeof labels === "function" ? labels(`r56.assertions.${slug}`) : labels[slug];
  return v && v !== `r56.assertions.${slug}` ? v : shortHead(key);
}

/** The header tooltip: the label plus the group ("(Tx)" / "(Bal)") where the key names one. */
export function assertionTitle(key, t) {
  const label = assertionLabel(key, t);
  const k = String(key || "");
  const grp = k.endsWith(" (Tx)") ? "tx" : k.endsWith(" (Bal)") ? "bal" : "";
  if (!grp) return label;
  const g = typeof t === "function" ? t(`r56.assertions.${grp}`) : null;
  return g && g !== `r56.assertions.${grp}` ? `${label} ${g}` : k;
}
